

export const AIG_AUTO = "AIG AUTO";
export const PRACTIAUTO = "PractiAuto";
export const AUTO_HOME_PREMIUM = "AUTO HOME PREMIUM";
export const AUTO_X_KM = "AUTOXKMDINERS";
export const RC_ANDINA = "RC ANDINA";

